const base_url = {
  api1: "https://crmapi.odisoft.in",
  file1: "https://crm.odisoft.in/crm_files",
};
export default base_url;